// Module
var code = "<input ng-disabled=\"disabled\" class=\"color\" value=\"#000000\" data-colormode=\"HEX\" readonly=\"\" style=\"background-color:#b6bd79;color:transparent;cursor:pointer\"/> ";
// Exports
module.exports = code;